import {
    defineMessages
} from 'react-intl';

export const messages = defineMessages({
    "WhyJoin": {
        "id": "HomeTopBar.WhyJoin",
        "defaultMessage": "Why Join"
    },
    "HowToJoin": {
        "id": "HomeTopBar.HowToJoin",
        "defaultMessage": "How To Join"
    },
    "AboutUs": {
        "id": "HomeTopBar.AboutUs",
        "defaultMessage": "About Us"
    },
    "Commission": {
        "id": "HomeTopBar.Commission",
        "defaultMessage": "Commission"
    },
    "Username": {
        "id": "HomeTopBar.Username",
        "defaultMessage": "Username"
    },
    "Password": {
        "id": "HomeTopBar.Password",
        "defaultMessage": "Password"
    },
    "RememberMe": {
        "id": "HomeTopBar.RememberMe",
        "defaultMessage": "Remember Me"
    },
    "ForgotPassword": {
        "id": "HomeTopBar.ForgotPassword",
        "defaultMessage": "Forgot Password?"
    },
    "Login": {
        "id": "HomeTopBar.Login",
        "defaultMessage": "Login"
    },
    "JoinNow": {
        "id": "HomeTopBar.JoinNow",
        "defaultMessage": "Join Now"
    },
    "ChangeLanguage": {
        "id": "HomeTopBar.ChangeLanguage",
        "defaultMessage": "Change Language"
    },
    "Chinese": {
        "id": "HomeTopBar.Chinese",
        "defaultMessage": "Chinese"
    },
    "English": {
        "id": "HomeTopBar.English",
        "defaultMessage": "English"
    },
    "Thai": {
        "id": "HomeTopBar.Thai",
        "defaultMessage": "ประเทศไทย"
    },
    "Indo": {
        "id": "HomeTopBar.Indo",
        "defaultMessage": "Bahasa Indo"
    },
    "Vien": {
        "id": "HomeTopBar.Vien",
        "defaultMessage": "Tiếng Việt"
    },
    "SectionOneTitle1": {
        "id": "HomeTopBar.SectionOneTitle1",
        "defaultMessage": "Million Commission, Retire Early"
    },
    "SectionOneTitle2": {
        "id": "HomeTopBar.SectionOneTitle2",
        "defaultMessage": "low requirement, easy to operate"
    },
    "WhyJoinFUN88": {
        "id": "HomeTopBar.WhyJoinFUN88",
        "defaultMessage": "Why Join FUN88"
    },
    "SectionTwoDescription1_Title": {
        "id": "HomeTopBar.SectionTwoDescription1_Title",
        "defaultMessage": "IMPECCABLE BRAND REPUTATION"
    },
    "SectionTwoDescription1": {
        "id": "HomeTopBar.SectionTwoDescription1",
        "defaultMessage": "-International brand with a history of working with world class sports teams and renowned ambassadors"
    },
    "SectionTwoDescription2_Title": {
        "id": "HomeTopBar.SectionTwoDescription2_Title",
        "defaultMessage": "GREAT PRODUCTS AND THE BEST TOOLS"
    },
    "SectionTwoDescription2": {
        "id": "HomeTopBar.SectionTwoDescription2",
        "defaultMessage": "GREAT PRODUCTS AND THE BEST TOOLS \n-Wide variety of products to cater to your customer's needs and targeting a broad spectrum of target audience \n-Variety of marketing tools and technology to boost your conversion and retention rates"
    },
    "SectionTwoDescription3_Title": {
        "id": "HomeTopBar.SectionTwoDescription3_Title",
        "defaultMessage": "CUSTOMER EXPERIENCE"
    },
    "SectionTwoDescription3": {
        "id": "HomeTopBar.SectionTwoDescription3",
        "defaultMessage": "-Structured teams to optimize every player's journey "
    },
    "SectionTwoDescription4_Title": {
        "id": "HomeTopBar.SectionTwoDescription4_Title",
        "defaultMessage": "DEDICATED SUPPORT"
    },
    "SectionTwoDescription4": {
        "id": "HomeTopBar.SectionTwoDescription4",
        "defaultMessage": "- 24/7 support for you and your customers \n- Extensive payment methods for your commissions"
    },
    "SectionTwoDescription5_Title": {
        "id": "HomeTopBar.SectionTwoDescription5_Title",
        "defaultMessage": "BECAUSE YOU MATTER"
    },
    "SectionTwoDescription5": {
        "id": "HomeTopBar.SectionTwoDescription5",
        "defaultMessage": "- Customer risk management to drive your revenues \n- Different team of analyst to ensure your customers stay active and engaged on our site"
    },
    "SectionTwoDescription6": {
        "id": "HomeTopBar.SectionTwoDescription6",
        "defaultMessage": "Vast varieties of gaming product choices"
    },
    "SectionTwoDescription7": {
        "id": "HomeTopBar.SectionTwoDescription7",
        "defaultMessage": "Licensed and secure platform"
    },
    "SectionThreeTitle1": {
        "id": "HomeTopBar.SectionThreeTitle1",
        "defaultMessage": "HOW TO START"
    },
    "SectionThreeTitle2Step1": {
        "id": "HomeTopBar.SectionThreeTitle2Step1",
        "defaultMessage": "1. Fill in, turn your traffic source into customer"
    },
    "SectionThreeTitle2Step2": {
        "id": "HomeTopBar.SectionThreeTitle2Step2",
        "defaultMessage": "2. Verification, dedicated manager to help you throughtout the process"
    },
    "SectionThreeTitle2Step3": {
        "id": "HomeTopBar.SectionThreeTitle2Step3",
        "defaultMessage": "3. Promoting, make sure the tools and start promoting"
    },
    "SectionThreeTitle2Step4": {
        "id": "HomeTopBar.SectionThreeTitle2Step4",
        "defaultMessage": "4. Earn commission- easy and stable"
    },
    "JOINNOW": {
        "id": "HomeTopBar.JOINNOW",
        "defaultMessage": "JOIN NOW"
    },
    "AboutFun88": {
        "id": "HomeTopBar.AboutFun88",
        "defaultMessage": "About Fun88"
    },
    "SectionFourDescription": {
        "id": "HomeTopBar.SectionFourDescription",
        "defaultMessage": "Fun88 is an all-in-one entertainment website, also available in its own APP technology, offering online gaming products from sportsbook, in-play sports betting, live casino, slot games, lottery products and more! A proud sponsor and partner of EPL clubs including Tottenham Hotspur, and Newcastle United, with sports legends as brand ambassadors like Steve Nash and Robbie Fowler. Striving to provide the best customer experience, we offer promotions ranging from big bonuses to special treats and freebies, and access to our rewards program with exclusive items."
    },
    "lblLiveChat": {
        "id": "Sidebar.LiveChat",
        "defaultMessage": "Live Chat"
    },
    "lblTelegram": {
        "id": "lblTelegram",
        "defaultMessage": "Telegram"
    },
    "lblLetstalk": {
        "id": "lblLetstalk",
        "defaultMessage": "Letstalk"
    },
    "ContactUs": {
        "id": "HomeTopBar.ContactUs",
        "defaultMessage": "Contact Us"
    },
    "operationHourCN1_Landing": {
        "id": "operationHourCN1_Landing",
        "defaultMessage": "Common Issues （9:00 am - 2:00 am Beijing time）"
    },
    "operationHourCN2_Landing": {
        "id": "operationHourCN2_Landing",
        "defaultMessage": "Business, promotion, support, joint venture issues （10:00 am - 7:00 pm Beijing time）"
    },
    "ContactUs_Header_Landing_CN": {
        "id": "ContactUs_Header_Landing_CN",
        "defaultMessage": "任何问题，可以透过以下方式与我们的专员来进行联系，我们的专员会竭诚协助您的业务。"
    },
    "lblQQ": {
        "id": "lblQQ",
        "defaultMessage": "QQ"
    },
    "QQ_CN": {
        "id": "QQ_CN",
        "defaultMessage": "3007316118"
    },
    "Skype_CN": {
        "id": "Skype_CN",
        "defaultMessage": "live:.cid.ea67bbd313a2eb89"
    },
    "Email_CN": {
        "id": "Email_CN",
        "defaultMessage": "daili@fun88.com"
    },
    "lblSkype": {
        "id": "lblSkype",
        "defaultMessage": "Skype"
    },
    "lblEmail": {
        "id": "lblEmail",
        "defaultMessage": "Email"
    },
    "lblFlygram": {
        "id": "lblFlygram",
        "defaultMessage": "Flygram"
    },
    "lblBatchat": {
        "id": "lblBatchat",
        "defaultMessage": "Batchat"
    },
    "Telegram_CN": {
        "id": "Telegram_CN",
        "defaultMessage": "@fun88088"
    },
    "Flygram_CN": {
        "id": "Flygram_CN",
        "defaultMessage": "FUN8888"
    },
    "Batchat_CN": {
        "id": "Batchat_CN",
        "defaultMessage": "7125750"
    }
})